import React from 'react';
import { motion } from 'framer-motion';
import { 
  AlertTriangle, 
  Bell, 
  Power,
  CheckCircle
} from 'lucide-react';
import { MonitoringStatus, AlertHistory } from '../../../types/solarMonitoring';

interface OverviewTabProps {
  monitoringStatus: MonitoringStatus | null;
  alertHistory: AlertHistory[];
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ 
  monitoringStatus, 
  alertHistory 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-lg shadow-sm p-6 border"
      >
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-green-100 rounded-full">
            <CheckCircle className="h-6 w-6 text-green-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Active Rules</p>
            <p className="text-2xl font-bold text-gray-900">
              {monitoringStatus?.activeRules || 0}
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="bg-white rounded-lg shadow-sm p-6 border"
      >
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-yellow-100 rounded-full">
            <AlertTriangle className="h-6 w-6 text-yellow-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Current Violations</p>
            <p className="text-2xl font-bold text-gray-900">
              {monitoringStatus?.currentViolations || 0}
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="bg-white rounded-lg shadow-sm p-6 border"
      >
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-blue-100 rounded-full">
            <Power className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Last Output</p>
            <p className="text-2xl font-bold text-gray-900">
              {monitoringStatus?.lastAlert?.powerData?.percentageOutput?.toFixed(1) || '--'}%
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="bg-white rounded-lg shadow-sm p-6 border"
      >
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-red-100 rounded-full">
            <Bell className="h-6 w-6 text-red-600" />
          </div>
          <div>
            <p className="text-sm text-gray-600">Total Alerts</p>
            <p className="text-2xl font-bold text-gray-900">
              {alertHistory.length}
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};